import React from "react";
import { Button, Menu, MenuItem } from "@blueprintjs/core";
import { Classes, Popover2 } from "@blueprintjs/popover2";

/**
 * Transforms text to uppercase.
 * @param {string} text - Original text
 * @returns {string} Transformed text
 */
function toUpperCase(text) {
	if (text == null || typeof text !== "string") return text;
	return text.toUpperCase();
}

/**
 * Transforms text to lowercase.
 * @param {string} text - Original text
 * @returns {string} Transformed text
 */
function toLowerCase(text) {
	if (text == null || typeof text !== "string") return text;
	return text.toLowerCase();
}

/**
 * Capitalizes the first letter of every word.
 * @param {string} text - Original text
 * @returns {string} Transformed text
 */
function capitalizeWords(text) {
	if (text == null || typeof text !== "string") return text;
	return text.replace(/\b\w/g, (char) => char.toUpperCase());
}

export function TextCaseControl(editor) {
	const { Canvaseditor, disabledObj } = editor;

	const applyCase = (transformFn) => {
		const obj = Canvaseditor?.getActiveObject();
		if (!obj || obj.type !== "textbox") return;

		const currentText = obj.get("text") ?? "";
		const transformed = transformFn(currentText);

		obj.set("text", transformed);
		Canvaseditor.renderAll();
		if (typeof Canvaseditor.fire === "function") {
			Canvaseditor.fire("object:modified");
		}
	};

	return (
		<div className="text-case-control">
			<Popover2
				interactionKind="click"
				popoverClassName={Classes.POPOVER2_CONTENT_SIZING}
				placement="bottom"
				content={
					<Menu>
						<MenuItem
							onClick={() => applyCase(toUpperCase)}
							text="UPPERCASE"
							style={{ textTransform: "uppercase" }}
						/>
						<MenuItem
							onClick={() => applyCase(toLowerCase)}
							text="lowercase"
							style={{ textTransform: "lowercase" }}
						/>
						<MenuItem
							onClick={() => applyCase(capitalizeWords)}
							text="Capitalize Each Word"
						/>
					</Menu>
				}
				renderTarget={({ isOpen, ref, ...targetProps }) => (
					<Button
						{...targetProps}
						elementRef={ref}
						disabled={disabledObj}
						title="Change text case"
						minimal
						style={{ fontWeight: 600, fontSize: 14 }}
					>
						Aa
					</Button>
				)}
			/>
		</div>
	);
}
